

(function showErrorDirectiveDefinition() {

    'use strict';

    // esta directiva hará que se seteen las clases de error automáticamente.    
    function showErrorDirectiveFactory(dirName, mode) {

        return ['$interpolate', function showErrorDirective($interpolate) {
            return {
                require: ['^form', dirName],
                restrict: 'A',
                controller: ['$scope', '$element', '$attrs',
                    function ($scope, $element, $attrs) {

                        var that = this;

                        this.mode = mode;

                        if ($attrs.showErrorMode) {
                            this.mode = $scope.$eval($attrs.showErrorMode);
                        }

                        switch (this.mode) {
                            case 'submit':
                            case 'attempt':
                                this.onSubmit = true;
                                break;
                            case 'always':
                                this.showAlways = true;
                                break;
                            case 'dirty':
                                break;
                            default:
                                console.debug('showErrorDirective: El modo "' + this.mode + '" es inválido. (' + $attrs[dirName] + ')');
                        }

                        this.inputName = $interpolate($attrs[dirName])($scope);  // por si tiene {{}}
                        
                        // esto es para el field y label error directive. Asi no hay tantos watches.
                        this.watchers = [];

                        $scope.$on('$destroy', function () {
                            that.watchers = null;
                        });
                        
                        this.update = function () {
                            angular.forEach(this.watchers, function (cb) {
                                cb(this);
                            }.bind(this));
                        };

                        this.onUpdate = function (callback) {
                            this.watchers.push(callback);
                        };

                    }],
                link: function showErrorClassDirectiveLink(scope, element, attrs, ctrls) {

                    var formCtrl = ctrls[0];
                    var myCtrl = ctrls[1];

                    function inputChanged(value) {

                        if (!angular.isUndefined(value)) {

                            if (formCtrl[myCtrl.inputName] === undefined) {
                                console.warn('showErrorDirective: ' + myCtrl.inputName + " no se encuentra definido");
                            } else {

                                var show = myCtrl.showAlways || (formCtrl.$submitted || (formCtrl[myCtrl.inputName].$dirty && !myCtrl.onSubmit));

                                element.removeClass('has-success');
                                element.removeClass('has-error');

                                if (show) {
                                    if (formCtrl[myCtrl.inputName].$invalid) {
                                        element.addClass('has-error');
                                    } else {
                                        element.addClass('has-success');
                                    }
                                }
                            }

                            myCtrl.update();
                        }
                    };

                    function submittedChanged(value) {
                        if (formCtrl[myCtrl.inputName])
                            return inputChanged(value);
                    }

                    // Escucho con string porque podría no existir aún el input.
                    scope.$watch(formCtrl.$name + '.' + myCtrl.inputName + '.$valid', inputChanged);
                    scope.$watch(formCtrl.$name + '.' + myCtrl.inputName + '.$dirty', inputChanged);

                    scope.$watch(formCtrl.$name + '.$submitted', submittedChanged);
                }
            };
        }];
    }

    angular.module('Errors')
        .directive('showErrorAlways', showErrorDirectiveFactory('showErrorAlways', 'always'))
        .directive('showError', showErrorDirectiveFactory('showError', 'dirty'))
        .directive('showErrorOnAttempt', showErrorDirectiveFactory('showErrorOnAttempt', 'submit'))
        .directive('showErrorOnSubmit', showErrorDirectiveFactory('showErrorOnSubmit', 'submit'));

})();